/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wide_Clear_Vole_MendInputs */

const en_wide_clear_vole_mend = /** @type {(inputs: Wide_Clear_Vole_MendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a round`)
};

const de_wide_clear_vole_mend = /** @type {(inputs: Wide_Clear_Vole_MendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Runde auswählen`)
};

/**
* | output |
* | --- |
* | "Select a round" |
*
* @param {Wide_Clear_Vole_MendInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const wide_clear_vole_mend = /** @type {((inputs?: Wide_Clear_Vole_MendInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wide_Clear_Vole_MendInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wide_clear_vole_mend(inputs)
	return de_wide_clear_vole_mend(inputs)
});